import styled from "styled-components";
import { SignupContainer, SignupWrapper } from "../signup/signup.style";

export const ForgotPasswordContainer = styled(SignupContainer)``;

export const ForgotPasswordWrapper = styled(SignupWrapper)``;
